import req from 'shared/req';
import {
  RECEIVE_COLLEGES,
  UPDATE_COLLEGE,
  followCollege,
  unfollowCollege,
} from 'shared/actions/college';
import {stopLoading} from 'shared/actions/loading';

export const getFollowedCollegeIds = () => (dispatch) =>
  req({
    url: '/v1/colleges?following',
    method: 'get',
    data: {
      fields: '_id',
      limit: 10000,
    },
  }).then((colleges) => {
    const formattedColleges = {};
    colleges.forEach((college) => (formattedColleges[college._id] = true));

    dispatch({
      type: RECEIVE_COLLEGES,
      colleges: formattedColleges,
    });
    dispatch(stopLoading('followedCollegeIds'));
  });

export const toggleFollow = (id) => (dispatch, getState) => {
  const {colleges: followedColleges} = getState();

  if (followedColleges[id]) {
    return unfollowCollege(id, () =>
      dispatch({
        type: UPDATE_COLLEGE,
        colleges: {[id]: false},
      })
    );
  } else {
    return followCollege(id, () =>
      dispatch({
        type: UPDATE_COLLEGE,
        colleges: {[id]: true},
      })
    );
  }
};
